/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NoResultFlag
 */
export interface NoResultFlag {
}

/**
 * Check if a given object implements the NoResultFlag interface.
 */
export function instanceOfNoResultFlag(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function NoResultFlagFromJSON(json: any): NoResultFlag {
    return NoResultFlagFromJSONTyped(json, false);
}

export function NoResultFlagFromJSONTyped(json: any, ignoreDiscriminator: boolean): NoResultFlag {
    return json;
}

export function NoResultFlagToJSON(value?: NoResultFlag | null): any {
    return value;
}

